import { drama } from '../../../../constants/actionTypes';

export default (state = false, action) => {
  switch (action.type) {
    case drama.POST_DRAMA_COMMENT:
      return true;

    case drama.POST_DRAMA_COMMENT_SUCCESS:
    case drama.POST_DRAMA_COMMENT_FAILED:
      return false;

    default:
      return state;
  }
};
